import axios from 'axios'
import loadingObj from '../utils/globalLoading';

const request = axios.create({
    // baseURL: 'http://192.168.10.188:8887/',
    // baseURL  :'https://vnapi.festiot.online',
    baseUrl : process.env.VUE_APP_BASE_API,
    // baseURL: 'http://1.13.18.50/:8887/',
    timeout: 30000,
})

// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
request.interceptors.request.use(config => {
    config.headers['Content-Type'] = 'application/json;charset=utf-8';
    let token=localStorage.getItem('token');
    if(token){
        config.headers['token'] = token;  // 设置请求头
    }
    loadingObj.showFullScreenLoading();
    return config
}, error => {
    loadingObj.tryHideFullScreenLoading();
    return Promise.reject(error)
});

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
    response => {
        let res = response.data;
        loadingObj.tryHideFullScreenLoading();
        // 如果是返回的文件
        if (response.config.responseType === 'blob') {
            return res
        }
        // 兼容服务端返回的字符串数据
        if (typeof res === 'string') {
            res = res ? JSON.parse(res) : res
        }
        // if(res.status===400){
        //     this.$router.push("/login")
        // }
        return res;
    },
    error => {
        loadingObj.tryHideFullScreenLoading();
        console.log('出错啦' + error) // for debug
        
        return Promise.reject(error)
    }
)


export default request
